import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { subMonths } from 'date-fns';

@Component({
  selector: 'slips-component',
  templateUrl: '../sharedTemplates/slips.component.html',
})
export class SlipsComponent implements OnInit, AfterViewInit, OnDestroy {
  slipTypeListB3000 = [];
  // @ViewChild("myElem") MyProp: ElementRef;
  openedPanelId = 0;
  scrollcord: any;

  slipsList = [];
  slipDetailList = [];

  selectedSlipType;
  selectedYear = new Date().getFullYear();
  selectedMonth = new Date().getMonth();
  slipTypeList = [];
  years = [];
  months = [];
  selectableDate = [];
  selectedSlipDate;
  today = new Date();
  translator = new TranslatePipe(this._LocalizationService);
  private subscriptionsToStopOnDestroy: Subscription[] = [];

  constructor(
    public _UiHelper: UiHelper,
    private _ApiService: ApiService,
    private _route: ActivatedRoute,
    private _router: Router,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService
  ) {}

  ngOnInit() {
    const today = new Date();
    const defaultMonth = today.getMonth();
    const defaultYear = today.getFullYear();

    this.years.push({
      year: defaultYear,
    });
    this.years.push({
      year: defaultYear - 1,
    });
    this.years.push({
      year: defaultYear - 2,
    });

    this.months = [
      { id: 0, name: 'January' },
      { id: 1, name: 'February' },
      { id: 2, name: 'March' },
      { id: 3, name: 'April' },
      { id: 4, name: 'May' },
      { id: 5, name: 'June' },
      { id: 6, name: 'July' },
      { id: 7, name: 'August' },
      { id: 8, name: 'September' },
      { id: 9, name: 'October' },
      { id: 10, name: 'November' },
      { id: 11, name: 'December' },
    ];

    this.slipTypeList = [
      { id: -40, name: 'All' },
      { id: 3, name: 'Won' },
      { id: 4, name: 'Lost' },
      { id: 2, name: 'Canceled' },
      { id: 1, name: 'Open' },
    ];
    this.slipTypeListB3000 = [
      { id: -40, name: this.translator.transform('All') },
      { id: 3, name: this.translator.transform('Won') },
      { id: 4, name: this.translator.transform('Lost') },
      { id: 2, name: this.translator.transform('Canceled') },
      { id: 1, name: this.translator.transform('Open') },
      { id: 7, name: this.translator.transform('Cashout') },
      { id: 8, name: this.translator.transform('Wait_Cashout') },
    ];

    this.selectableDate = [
      { id: 1, name: this.translator.transform('Last_1_Months', null) },
      { id: 3, name: this.translator.transform('Last_3_Months', null) },
      { id: 6, name: this.translator.transform('Last_6_Months', null) },
      { id: 12, name: this.translator.transform('Last_12_Months', null) },
    ];

    if (this._UiHelper.slips_selectedYear == 0) {
      this.selectedYear = defaultYear;
    } else {
      this.selectedYear = this._UiHelper.slips_selectedYear;
    }

    if (this._UiHelper.slips_selectedMonth == 0) {
      this.selectedMonth = defaultMonth;
    } else {
      this.selectedMonth = this._UiHelper.slips_selectedMonth;
    }

    if (this._UiHelper.slips_selectedSlipType == 0) {
      this.selectedSlipType = 1;
    } else {
      this.selectedSlipType = this._UiHelper.slips_selectedSlipType;
    }
    // this.selectedSlipType = 1;
    this.selectedSlipDate = 1;
    this.getSlips();
  }
  getScroll() {
    if (typeof document.getElementById('ticket_detail_id_' + this._UiHelper.selectedSlipDetail) != null) {
      try {
        this.scrollcord = document.getElementById('ticket_detail_id_' + this._UiHelper.selectedSlipDetail);
        setTimeout(() => {
          if (this.scrollcord != null) {
            this.scrollcord.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'nearest',
            });
          }
        }, 500);
      } catch (e) {
        console.warn('İtem not found.');
      }
    }
  }
  ngAfterViewInit() {
    this.subscriptionsToStopOnDestroy.push(
      this._UiHelper.selectedSlipDetailListener.subscribe(e => {
        this.getScroll();
        this.getSlips();
      })
    );

    if (this._UiHelper.rightMenu == true) {
      this._UiHelper.setRightMenu();
    }
    this._UiHelper.setNavbarTitle('slip_component');
  }

  onSlipTypeChange(newValue) {
    this._UiHelper.setLoadingDialog(true);
    this._UiHelper.slips_selectedSlipType = newValue;
    this.selectedSlipType = newValue;
    this.getSlips();
  }
  onSlipDateChange(Value: string): void {
    this._UiHelper.setLoadingDialog(true);
    if (Value) {
      this.selectedMonth = new Date(subMonths(this.today, Number(Value))).getMonth() + 1;
      this.selectedYear = new Date(subMonths(this.today, Number(Value))).getFullYear();
      this.getSlips();
    }
  }

  onYearsChange(newValue) {
    this._UiHelper.setLoadingDialog(true);
    this._UiHelper.slips_selectedYear = newValue;
    this.selectedYear = newValue;
    this.getSlips();
  }
  onMonthsChange(newValue) {
    this._UiHelper.setLoadingDialog(true);
    this._UiHelper.slips_selectedMonth = newValue;
    this.selectedMonth = newValue;
    this.getSlips();
  }

  getSlips() {
    this._ApiService.getSlips(this.selectedMonth, this.selectedYear, this.selectedSlipType).then(x => {
      if (x == '') {
        if (this._UserHelper.customerUser.CustomerId) {
          this._ApiService
            .getClient2()
            .then(result => {
              if (this._UserHelper.isSignedIn) {
                this._ApiService.getCashoutSlipsExternal(1);
              }
            })
            .catch();
        }
      }
      this.slipsList = x;
      setTimeout(() => this.getScroll(), 500);
      //console.log("SlipsList : ", this.slipsList);
      this._UiHelper.setLoadingDialog(false);
    });
  }

  getSlipDetail(obj) {
    ////console.log("SLIP_ID", obj.SlipId);

    //router.navigate(['/CustomerTransaction']);
    this._router.navigate(['/slipdetail', obj.SlipId]);

    // this._ApiService.getSlipDetail(obj.SlipId).then((x) => {
    //   this.slipDetailList = x;
    //   ////console.log("SlipDETAİLList : ", this.slipDetailList);
    // });
  }
  toggleTicketDetails(id) {
    if (this._UiHelper.selectedSlipDetail != 0) {
      id == this.openedPanelId;
      this._UiHelper.selectedSlipDetail = 0;
    } else {
      if (id == this.openedPanelId) {
        this.openedPanelId = 0;
      } else {
        this.openedPanelId = id;
      }
    }
  }

  ngOnDestroy() {
    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
  }
}
